<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div
        class="col-sm-12 list-container nopads"
    >
        <div v-if="resultList && resultList.length > 0" id="vehicle-list" class="list-content result-table mb-3">
            <vue3-datatable
                ref="resultTable"
                :rows="resultList"
                :columns="fields"
                :pagination="false"
                :sticky-header="true"
                :height="resultList.length > 5 ? '30vh' : '100%'"
                :sortable="true"
                skin="bh-table-compact"
                row-class="routa-table-row"
                cell-class="routa-table-cell"
                @row-click="onRowClick"
            >
                <template #user="row">
                    <div>
                        {{ row.value.user.first_name }} {{ row.value.user.last_name }}
                    </div>
                </template>
                <template #record_date="row">
                    <div>
                        {{ getShortDateString(row.value.record_date) }}
                    </div>
                </template>
                <template #record_end_date="row">
                    <div>
                        {{ getShortDateString(row.value.record_end_date) }}
                    </div>
                </template>
                <template #duty_officer="row">
                    <div>
                        {{ row.value && row.value.duty_officer ? row.value.duty_officer.first_name + ' ' + row.value.duty_officer.last_name : $t('contract_diary.not_defined') }}
                    </div>
                </template>
                <template #actions="row">
                    <button @click="emitEdit(row.value, $event)" class="btn btn-sm btn-outline-primary">
                        <i class="fas fa-pen"/>
                    </button>
                </template>
            </vue3-datatable>
        </div>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {printHelper} from '../mixins/PrintMixin'
import {restApi} from '../mixins/RestApiMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ContractWeeklyDiaryList',
    components: {Vue3Datatable},
    mixins: [timeUtils, printHelper, restApi],
    props: {
        results: {
            type: Array,
            default() {
                return []
            }
        },
        elyFields: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    data() {
        return {
            attachment: null,
            sortDesc: false,
            diarySortBy: 'report_date',
            resultList: []
        }
    },
    computed: {
        fields() {
            return [
                {field: 'record_date', title: this.$t('contract_diary.date'), sort: false, headerClass: 'routa-table-header'},
                {field: 'record_end_date', title: this.$t('contract_diary.end_date'), sort: false, headerClass: 'routa-table-header'},
                {field: 'user', title: this.$t('observations.reporter'), sort: false, headerClass: 'routa-table-header'},
                {field: 'events', title: this.$t('contract_diary.events'), sort: false, headerClass: 'routa-table-header'},
                {field: 'actions', title: '', sort: false, headerClass: 'routa-table-header', width: '80px'},
            ]
        }
    },
    watch: {
        results() {
            this.resultList = []
            this.$nextTick(() => {
                this.resultList = this.results
            })
        }
    },
    mounted() {
        this.resultList = this.results
    },
    methods: {
        emitEdit: function (result, event) {
            event.stopPropagation()
            let item = this.resultList.find(item => result.id === item.id)
            if (item) {
                this.$emit('edit', item)
            }
        },
        onRowClick: function (result) {
            let item = this.resultList.find(item => result.id === item.id)
            if (item) {
                this.$emit('rowClick', item)
            }
        }
    }
}
</script>

<style scoped>
.clickable {
    cursor: pointer;
}
</style>
